module.exports = __webpack_public_path__ + "static/media/nytimes.com_interactive_2016_01_07_travel_places-to-visit.html_plot.5e987971.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nytimes.com_interactive_2016_01_07_travel_places-to-visit.html_plot.png
// module id = 409
// module chunks = 0